import React from 'react';

const QtyStepper = ({ value, onChange, min = 0, max = 999 }) => {
  const dec = () => onChange(Math.max(min, value - 1));
  const inc = () => onChange(Math.min(max, value + 1));

  return (
    <div className="qty-stepper">
      <button className="qty-btn" onClick={dec} title="Decrease">−</button>
      <input
        className="qty-input"
        type="number"
        value={value}
        min={min}
        max={max}
        onChange={e => {
          const v = parseInt(e.target.value) || 0;
          onChange(Math.max(min, Math.min(max, v)));
        }}
      />
      <button className="qty-btn" onClick={inc} title="Increase">+</button>
    </div>
  );
};

export default QtyStepper;
